import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { courseFinancesApi } from "./courseFinancesApi";

export const useCourseFinance = (courseId: number, courseFinanceId: number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_FINANCES_BY_ID(courseFinanceId),
    queryFn: () => courseFinancesApi.fetchById(courseId, courseFinanceId),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_FINANCES_BY_ID(courseFinanceId),
    });
  };

  return { invalidate, isLoading, isFetching, courseFinance: data?.data };
};
